import { getTabIndex } from '@/datalayer/App.datalayer.utils';
import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';
import { pushClickToDL, TabsDLClick } from '../ComplexTabsList.datalayer';

enum Selectors {
  // Target
  CTA = 'a',
  Tab = '.gtm-tab',
  // Content
  CTAheadline = '[role="tabpanel"]:not([hidden]) .gtm-headline',
  TabHeadline = '.gtm-headline',
}

export const mapTarget = mapTargetBySelectors([Selectors.Tab, Selectors.CTA]);

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  const isTab = target?.classList.contains(Selectors.Tab.replace('.', ''));

  if (isTab) {
    const headlineId = target?.getAttribute('aria-controls')?.replace('-logos', '') || '';
    const documentHeadline =
      componentRef?.current?.querySelector(`#${headlineId} ${Selectors.TabHeadline}`)
        ?.textContent || '';

    return {
      event: 'clickTab',
      eventCategory: 'Complex Tab',
      ...(!!documentHeadline && { documentHeadline }),
      ...(!!documentHeadline && { tabLabel: documentHeadline }),
      ...(variantName && { variant_name: variantName }),
    };
  }

  const documentHeadline =
    componentRef?.current?.querySelector(Selectors.CTAheadline)?.textContent || '';

  // Scroll
  return {
    event: 'clickCTA',
    eventCategory: 'Complex Tab',
    documentHeadline,
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerTabClick = ({
  componentRef,
  target,
}: OnDatalayerProps): TabsDLClick | undefined => {
  if (!target || !componentRef?.current) {
    return undefined;
  }

  const tabElement = target.closest('[role=tab]') || target.closest('[role=tabpanel]');
  if (!tabElement) {
    return undefined;
  }

  const { id } = tabElement;
  const titleElement = componentRef?.current?.querySelector(
    `${Selectors.TabHeadline}-${getTabIndex(id)}`,
  );
  const title = titleElement?.children[0].textContent || '';

  return pushClickToDL({ title, target });
};
